import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFailFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Fail_full"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={8} fill="url(#Fail_full_svg__a)" />
    <path
      fill="#fff"
      d="M11 13.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1.8-3a.8.8 0 0 0 1.6 0V6a.8.8 0 0 0-1.6 0z"
    />
    <defs>
      <linearGradient
        id="Fail_full_svg__a"
        x1={15}
        x2={-5}
        y1={13.75}
        y2={13.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E04B44" />
        <stop offset={1} stopColor="#F4AEAC" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFailFull;
